'use client';
/* eslint-disable @nx/enforce-module-boundaries */
import { useState } from 'react';

import classNames from 'classnames';

import { Collapse } from '@uikit';

import { Typography } from '@ui/uikit/components/common/Typography';

import { Minus } from '../../icons/mono/Minus';
import { Plus } from '../../icons/mono/Plus';

type FAQItem = {
  question: string;
  answer: string;
};

type FaqProps = {
  faqItems: FAQItem[];
};

// @todo Add storybook stories when Collapse component will be moved to the new uikit
export const Faq = ({ faqItems }: FaqProps) => {
  const [accordionsState, setAccordionsState] = useState<Record<number, boolean>>({});

  return (
    <ul className="border-y border-base-border-medium">
      {faqItems.map((item, i) => {
        const isOpen = !!accordionsState[i];

        return (
          <li key={i} className="border-b border-base-border-medium last:border-none">
            <button
              className={classNames(
                'py-4 xl-msq:py-5 flex items-center text-left justify-between w-full gap-5',
                {
                  'pb-0 xl-msq:pb-0': isOpen,
                },
              )}
              onClick={() => {
                setAccordionsState((oldState) => {
                  return {
                    ...oldState,
                    [i]: !oldState[i],
                  };
                });
              }}
              data-qa="farm-staking-faq-item"
            >
              <Typography variant="h4">{item.question}</Typography>

              {isOpen ? (
                <Minus className="text-base-text-primary icon-xs" />
              ) : (
                <Plus className="text-base-text-primary icon-xs" />
              )}
            </button>

            <Collapse isOpen={isOpen}>
              <div
                className="pt-2 xl-msq:py-3 pb-4 xl-msq:pb-5 text-sm font-medium text-neutral-500 text-left"
                data-qa="farm-staking-faq-text"
                dangerouslySetInnerHTML={{ __html: item.answer }}
              ></div>
            </Collapse>
          </li>
        );
      })}
    </ul>
  );
};
